module.exports = __webpack_public_path__ + "media/images/s02_02_en-186ff707fb2771b17099b86da928f69a.svg";